__turbopack_context__.v({
  "incomplete": "TeamProfileSocialLink-module-scss-module__fzSKbW__incomplete",
  "link": "TeamProfileSocialLink-module-scss-module__fzSKbW__link",
  "root": "TeamProfileSocialLink-module-scss-module__fzSKbW__root",
});
